// generated by genversion
export const version = '2.4.7'



// WEBPACK FOOTER //
// ../lib/version.js